/* KeldCo: the cart is the drawer, 2026-09-22.

   The theme already opens the drawer from the header, because that link
   carries aria-controls="cart-drawer". Anything else that points at the cart
   page -- a footer link, an app, a section a merchant adds later -- would
   navigate away instead. This catches those and opens the drawer.

   Deliberately NOT handled: someone who lands on /cart directly, by typing
   it, from an email, or with the back button. Redirecting a real page away
   from under them breaks the back button and the no-JS fallback, and /cart
   has to keep working when this script does not run. */
(function () {
  if (window.KC_CART_DRAWER) return;
  window.KC_CART_DRAWER = true;

  function cartPath() {
    var r = window.Shopify && window.Shopify.routes && window.Shopify.routes.cart_url;
    return r || '/cart';
  }

  /* Set by the redirect at the top of sections/main-cart.liquid, so the
     drawer opens on the page we bounced back to. */
  function openIfFlagged() {
    var flagged;
    try { flagged = sessionStorage.getItem('kcOpenDrawer'); } catch (e) { return; }
    if (!flagged) return;
    try { sessionStorage.removeItem('kcOpenDrawer'); } catch (e) {}
    var tries = 0;
    (function attempt() {
      var d = document.querySelector('cart-drawer');
      if (d && typeof d.show === 'function') { try { d.show(); } catch (e) {} return; }
      if (++tries < 20) setTimeout(attempt, 150);
    }());
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', openIfFlagged);
  } else {
    openIfFlagged();
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href]');
    if (!a) return;

    /* The theme's own handler already owns these. */
    if (a.getAttribute('aria-controls')) return;

    var url;
    try { url = new URL(a.href, window.location.origin); } catch (err) { return; }
    if (url.origin !== window.location.origin) return;

    /* The cart page itself, not /cart/add.js, /cart/change.js or /cart/clear.js. */
    var path = url.pathname.replace(/\/$/, '');
    if (path !== cartPath().replace(/\/$/, '')) return;

    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.show !== 'function') return;  /* let it navigate */

    e.preventDefault();
    try { drawer.show(); } catch (err) { window.location.href = a.href; }
  }, true);
}());
